
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/ai/ui/businessTypeInput/businessTypeInput.scss.css.virtualfile';
        module.exports = {"input":"_input_mm0b8_7"};